"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFullStory = void 0;
exports.getFullStory = function () { return window.FS; };
